import { useEffect, useRef } from "react";

export default function Turnstile({ onVerify, onExpire }) {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useEffect(() => {
        const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
        if (!siteKey) {
            console.warn("REACT_APP_TURNSTILE_SITE_KEY not set — bypassing Turnstile");
            onVerify?.("dev-bypass");
            return;
        }

        const interval = setInterval(() => {
            if (window.turnstile && containerRef.current) {
                clearInterval(interval);
                widgetIdRef.current = window.turnstile.render(containerRef.current, {
                    sitekey: siteKey,
                    callback: (token) => onVerify?.(token),
                    "expired-callback": () => onExpire?.(),
                    theme: "dark",
                });
            }
        }, 100);

        return () => {
            clearInterval(interval);
            if (widgetIdRef.current !== null && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
            }
        };
    }, []);

    return <div ref={containerRef} style={{ marginBottom: "1rem" }} />;
}